import { Component, OnInit, Input, SimpleChanges, ViewChild, AfterViewInit, Output, EventEmitter, ElementRef, HostListener } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { TimeSeriesDetail } from 'src/app/models/dashboard';
import { ElapsedTimeService } from '../../../service/elapsed-time.service';
import { Zone } from 'src/api/models';
import { FireService } from 'src/service/fire.service';
import { FireForesightService } from 'src/api/services';

interface PreviousLightStackElement {
  key: string;
  element: Element;
}

interface Box {
  bearing: number;
  tilt: number;
  width: number;  // degrees
  height: number; // degrees
}

interface Image {
  bearing: number;
  tilt: number;
  fieldOfView: number; // degrees
  ratio: { width: number, height: number };
}

interface BoxEdges {
  id: number;
  top: number;    // percentage
  left: number;   // percentage
  //right: number;  // percentage
  //bottom: number; // percentage
  width: number;
  height: number;
  confidence: number;
}

type ZoneResizeEdge = 'top' | 'right' | 'bottom' | 'left';

function calculateBoxEdges(id: number, image: Image, box: Box, confidence: number): BoxEdges {
  const offset = image.fieldOfView;
  
  // Calculate the width and height of the image in degrees
  const imageWidthDegrees = image.fieldOfView;// * (image.ratio.width / (image.ratio.width + image.ratio.height));
  const imageHeightDegrees = image.fieldOfView / image.ratio.width * image.ratio.height;// * (image.ratio.height / (image.ratio.width + image.ratio.height));

  // calculate camera edges in degrees
  const imageTop = image.tilt + imageHeightDegrees / 2;
  let imageLeft = image.bearing - imageWidthDegrees / 2;
  if (imageLeft < image.fieldOfView/2){
    imageLeft = imageLeft + 360;
  }

  const boxTop = (box.tilt + box.height / 2);// - image.tilt;
  let boxLeft = (box.bearing - (box.width/2));

  // Calculate box edges in degrees
  if (boxLeft < imageLeft){
    boxLeft += 360
  }
  const left = (boxLeft - imageLeft) / imageWidthDegrees * 100;
  const top = (imageTop - boxTop) / imageHeightDegrees * 100;
  
  const height = box.height / imageHeightDegrees * 100;
  const width = box.width / imageWidthDegrees * 100;

  return {
    id: id,
    top: top,
    left: left,
    //right: 100 - rightPercentage,
    //bottom: 100 - bottomPercentage,
    width: width,
    height: height,
    confidence: confidence
  };
}

@Component({
  selector: 'smart-image',
  templateUrl: './smart-image.component.html',
  styleUrls: ['./smart-image.component.css']
})
export class SmartImageComponent implements OnInit, AfterViewInit { 
  @ViewChild('imageSource') imageSource: ElementRef;
  
  @Input() showZones: boolean;

  //_zones: Zone[];
  public zonesstr: string;
  public _zones: BoxEdges[];
  public _zoneSource: Zone[];
  @Input() set zones(zones: Zone[]){
      this._zoneSource = zones;
      // show the latest image
      let boxes = [];
      if (zones != null){
        for (let zone of zones){
          // Example usage
          const image: Image = {
            bearing: zone.cameraBearing,
            tilt: zone.cameraElevation,
            fieldOfView: zone.cameraFieldOfView,
            ratio: { width: 16, height: 9 },
          };

          const box: Box = {
            bearing: zone.bearing,
            tilt: zone.elevation,
            width: zone.width,  // degrees
            height: zone.height // degrees
          };

          const edges = calculateBoxEdges(zone.id, image, box, zone.confidence);
          boxes.push(edges);
          this.selectZone(edges);
        }
      }
      this._zones = boxes;
      this.zonesstr = JSON.stringify(zones);
      console.log("zones", zones);
      
    };

  @Input() showLineAt: any;
  @Input() overlayConfig: any;
  @Input() src: string;
  @Input() showMetaData: boolean;
  
  @Output() objectSelected = new EventEmitter<any>();
  @Output() pointerEvent = new EventEmitter<any>();
  @Output() clickEvent = new EventEmitter<any>();

  @Input() public aspectRatio: string = '16:9';
  @Input() public isLoaded: boolean = false;
  downloaded: boolean = false;
  showOverlay: boolean = true;
  toggleOverlay: boolean = true;

  x: number;
  public showImg: boolean = true;
  error: boolean = false;

  imageRef:any;
  imageRefTarget:any;

  overlays: any[]

  // Zoom and pan properties
  scale: number = 1;
  minScale: number = 1;
  maxScale: number = 3;
  translateX: number = 0;
  translateY: number = 0;
  isDragging: boolean = false;
  dragStartX: number = 0;
  dragStartY: number = 0;
  lastTouchDistance: number = 0;
  lastTapTime: number = 0;
  lastTapX: number = 0;
  lastTapY: number = 0;

  constructor(private svc: FireForesightService) {
 
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.showImage();
  }

  ngOnInit(): void {
    if (this.aspectRatio == null){
      this.aspectRatio = '16:9';
    }
  }

  ngAfterViewInit() {
    this.showImage();
  }

  public showImage(forceShow: boolean = true) {
    if (forceShow){
      this.showImg = true;
    }
    if (this.imageSource){
      const img = this.imageSource.nativeElement;
      img.onload = (i: any) => {
        this.imageRef = i;
        this.imageRefTarget = i.target;
      };
      // Check if image is already loaded (from cache)
      if (img.complete && img.naturalWidth > 0) {
        this.imageRef = { target: img };
        this.imageRefTarget = img;
      }
    }
    if (this.src){
      if (this.overlayConfig) {
        console.log('[SmartImage] Overlay config received:', this.overlayConfig);
        console.log('[SmartImage] Overlay config type:', typeof this.overlayConfig);
        const imageOverlay = JSON.parse(this.overlayConfig);
        console.log('[SmartImage] Parsed overlay:', imageOverlay);
        const timg = new Image();
        timg.onload = (i: any) => {
          this.overlays = [];
          this.imageRef = i;
          //this.imageRefTarget = i.target;
          this.downloaded = true;
          this.error = false;
          
          const imgWidth = i.target.width;
          const imgHeight = i.target.height;
          console.log('[SmartImage] Image dimensions:', imgWidth, 'x', imgHeight);
          
          for (let obj of imageOverlay.objects){
            const startX = (obj.rectangle.x / imgWidth) * 100;
            const startY = (obj.rectangle.y / imgHeight) * 100;
            const width = (obj.rectangle.w / imgWidth) * 100;
            const height = (obj.rectangle.h / imgHeight) * 100;
            this.overlays.push({x:startX,y:startY,w:width,h:height,name:obj.object,confidence:obj.confidence});
          }
          console.log('[SmartImage] Overlays created:', this.overlays);
        };
        timg.src = this.src;
      }
      else{
        console.log('[SmartImage] No overlayConfig provided');
        this.overlays = [];
      }
    }
  }

  onImageLoad(event: Event) {
    const img = event.target as HTMLImageElement;
    this.imageRef = event;
    this.imageRefTarget = img;
  }

  onPointerEvent(event){
    //console.log(event);
    if (this.pointerEvent == null) return;
    if (this.isDragging) return; // Don't emit pointer events while dragging

    const img = this.imageSource.nativeElement;
    const bounds=img.getBoundingClientRect();
    const left=bounds.left;
    const top=bounds.top;
    var x = event.pageX - left;
    var y = event.pageY - top;
    const imgWidth = this.imageRefTarget?.width;
    const imgHeight = this.imageRefTarget?.height;
    x = x/imgWidth * 100;
    y = y/imgHeight * 100;
    x = Math.round(x);
    y = Math.round(y);
    //console.log(`${x}% ${y}%`);
    this.pointerEvent.emit({x:x,y:y});

    this.x = x;
  }

  onImageClick(event: MouseEvent): void {
    const img = this.imageRefTarget;
    if (!img) return;
    
    const bounds = img.getBoundingClientRect();
    const left = bounds.left;
    const top = bounds.top;
    var x = event.pageX - left;
    var y = event.pageY - top;
    const imgWidth = this.imageRefTarget?.width;
    const imgHeight = this.imageRefTarget?.height;
    x = x / imgWidth * 100;
    y = y / imgHeight * 100;
    x = Math.round(x);
    y = Math.round(y);
    
    this.clickEvent.emit({x: x, y: y});
  }

  selectedZone: BoxEdges;
  private resizingZone: BoxEdges | null = null;
  private resizeEdge: ZoneResizeEdge | null = null;
  private resizeStartX = 0;
  private resizeStartY = 0;
  private resizeStartZone: BoxEdges | null = null;

  selectZone(zone: BoxEdges){
    console.log("selectZone", zone);
    this.selectedZone = zone;
  }

  onZoneResizeStart(event: PointerEvent, zone: BoxEdges, edge: ZoneResizeEdge): void {
    event.preventDefault();
    event.stopPropagation();
    this.selectZone(zone);
    this.resizingZone = zone;
    this.resizeEdge = edge;
    this.resizeStartX = event.clientX;
    this.resizeStartY = event.clientY;
    this.resizeStartZone = { ...zone };
  }

  @HostListener('document:pointermove', ['$event'])
  onZoneResizeMove(event: PointerEvent): void {
    if (!this.resizingZone || !this.resizeEdge || !this.resizeStartZone || !this.imageSource) return;

    const imageBounds = this.imageSource.nativeElement.getBoundingClientRect();
    if (imageBounds.width <= 0 || imageBounds.height <= 0) return;

    const deltaX = (event.clientX - this.resizeStartX) / imageBounds.width * 100;
    const deltaY = (event.clientY - this.resizeStartY) / imageBounds.height * 100;
    const minimumWidth = 2 / imageBounds.width * 100;
    const minimumHeight = 2 / imageBounds.height * 100;
    const start = this.resizeStartZone;

    switch (this.resizeEdge) {
      case 'left': {
        const right = start.left + start.width;
        const left = this.clamp(start.left + deltaX, 0, right - minimumWidth);
        this.resizingZone.left = left;
        this.resizingZone.width = right - left;
        break;
      }
      case 'right':
        this.resizingZone.width = this.clamp(start.width + deltaX, minimumWidth, 100 - start.left);
        break;
      case 'top': {
        const bottom = start.top + start.height;
        const top = this.clamp(start.top + deltaY, 0, bottom - minimumHeight);
        this.resizingZone.top = top;
        this.resizingZone.height = bottom - top;
        break;
      }
      case 'bottom':
        this.resizingZone.height = this.clamp(start.height + deltaY, minimumHeight, 100 - start.top);
        break;
    }

    event.preventDefault();
  }

  @HostListener('document:pointerup')
  onZoneResizeEnd(): void {
    this.resizingZone = null;
    this.resizeEdge = null;
    this.resizeStartZone = null;
  }

  private clamp(value: number, minimum: number, maximum: number): number {
    return Math.min(Math.max(value, minimum), maximum);
  }
  
  deleteZone(zone: BoxEdges){
    this.svc.FireForesightDeleteIgnoreZone(zone.id).subscribe(r => {
      const index = this._zones.indexOf(zone);
      if (index !== -1) {
        this._zones.splice(index, 1);
      }
      if (this._zones.length == 0){
              this.selectedZone = null;      
      }else{
        this.selectedZone = this._zones[0];
      }
    })
  }

  zoneLeft(zone: BoxEdges, step: number) {
    if (zone.left <= 0) return;
    zone.left = zone.left - step;
    //zone.width = zone.width - number;
  }

  zoneLeftFull(zone: BoxEdges) {
    if (zone.left <= 0) return;
    zone.left = 0;
    //zone.width = zone.width - number;
  }

  zoneRight(zone: BoxEdges) {
    if (zone.left + zone.width >= 100) return;
    zone.left = zone.left + 0.1;
    //zone.width = zone.left + 1;
  }

  zoneUp(zone: BoxEdges, step: number) {
    if (zone.top <= 0) return;
    zone.top = zone.top - step;
    //zone.width = zone.width - number;
  }

  zoneUpFull(zone: BoxEdges) {
    zone.top = 0;
  }

  zoneDown(zone: BoxEdges) {
    if (zone.top + zone.height >= 100) return;
    zone.top = zone.top + 0.1;
    //zone.width = zone.left + 1;
  }

  zoneWidth(zone: BoxEdges, number: number) {
    if (zone.width >= 100) return;
    zone.width = zone.width + (0.1 * number);
  }

  zoneWidthFull(zone: BoxEdges, number: number) {
    zone.width = 100;
  }
  
  zoneHeight(zone: BoxEdges, number: number) {
    if (zone.height >= 100) return;
    zone.height = zone.height + (0.1 * number);
  }

  zoneSave(zone: BoxEdges) {
    // convert left/top/width/height (percentage) to x/y/w/h (pixels)
    var startX = Math.round((zone.left / 100) * this.imageRefTarget.naturalWidth);
    var startY = Math.round((zone.top / 100) * this.imageRefTarget.naturalHeight);
    var width = Math.round((zone.width / 100) * this.imageRefTarget.naturalWidth);
    var height = Math.round((zone.height / 100) * this.imageRefTarget.naturalHeight);

    // check without image bounds
    if (startX < 0) startX = 0;
    if (startY < 0) startY = 0;
    if (startX + width > this.imageRefTarget.naturalWidth) {
      width = this.imageRefTarget.naturalWidth - startX;
    }
    if (startY + height > this.imageRefTarget.naturalHeight) {
      height = this.imageRefTarget.naturalHeight - startY;
    }
   
    var results = {
      objects:[{
          object:'Ignore Zone',
          confidence: zone.confidence/100, 
          rectangle:{ 
            x: startX, 
            y: startY, 
            h: height, 
            w: width
          }
        }
    ]
  };
    var z = this._zoneSource.find(z => z.id === zone.id);
    if (z != null) {
      this.svc.FireForesightUpdateIgnoreZone({
          IncidentId: z.id,
          Width: z.width,
          Height: z.height,
          CameraBearing: z.cameraBearing,
          CameraElevation: z.cameraElevation,
          CameraFieldOfView: z.cameraFieldOfView,
          SiteUri: z.site.siteUri,
          DetectionMetaData: JSON.stringify(results)
      }).subscribe(result => {
        this.selectedZone = null;
      });

    }
  }

  // Mouse wheel zoom
  onWheel(event: WheelEvent) {
    event.preventDefault();
    const delta = -event.deltaY;
    const zoomIntensity = 0.001;
    
    const prevScale = this.scale;
    this.scale = Math.min(Math.max(this.scale + delta * zoomIntensity, this.minScale), this.maxScale);
    
    // Adjust pan position to zoom towards cursor
    if (this.imageSource) {
      const img = this.imageSource.nativeElement;
      const wrapper = img.parentElement; // demo-img-wrapper
      const container = wrapper.parentElement; // demo-img-container
      
      if (container) {
        const containerRect = container.getBoundingClientRect();
        // Get mouse position relative to the container
        const mouseX = event.clientX - containerRect.left;
        const mouseY = event.clientY - containerRect.top;
        
        // Calculate center of container (since transform-origin is center)
        const centerX = containerRect.width / 2;
        const centerY = containerRect.height / 2;
        
        // Mouse offset from center
        const offsetX = mouseX - centerX;
        const offsetY = mouseY - centerY;
        
        const scaleChange = this.scale / prevScale;
        // Adjust translation to keep the point under the cursor fixed
        this.translateX = offsetX - (offsetX - this.translateX) * scaleChange;
        this.translateY = offsetY - (offsetY - this.translateY) * scaleChange;
        
        this.constrainPan();
      }
    }
  }

  // Double-click zoom
  onDoubleClick(event: MouseEvent) {
    event.preventDefault();
    
    if (!this.imageSource) return;
    
    const wrapper = this.imageSource.nativeElement.parentElement;
    const container = wrapper?.parentElement;
    if (!container) return;
    
    const containerRect = container.getBoundingClientRect();
    const clickX = event.clientX - containerRect.left;
    const clickY = event.clientY - containerRect.top;
    
    this.zoomToPoint(clickX, clickY, containerRect.width, containerRect.height);
  }

  // Mouse drag start
  onMouseDown(event: MouseEvent) {
    if (this.scale > 1) {
      this.isDragging = true;
      this.dragStartX = event.clientX - this.translateX;
      this.dragStartY = event.clientY - this.translateY;
      event.preventDefault();
    }
  }

  // Mouse drag move
  onMouseMove(event: MouseEvent) {
    if (this.isDragging) {
      this.translateX = event.clientX - this.dragStartX;
      this.translateY = event.clientY - this.dragStartY;
      this.constrainPan();
      event.preventDefault();
    }
  }

  // Mouse drag end
  onMouseUp(event: MouseEvent) {
    this.isDragging = false;
  }

  // Touch pinch to zoom
  onTouchStart(event: TouchEvent) {
    if (event.touches.length === 2) {
      const touch1 = event.touches[0];
      const touch2 = event.touches[1];
      this.lastTouchDistance = this.getTouchDistance(touch1, touch2);
    } else if (event.touches.length === 1 && this.scale > 1) {
      this.isDragging = true;
      this.dragStartX = event.touches[0].clientX - this.translateX;
      this.dragStartY = event.touches[0].clientY - this.translateY;
    }
  }

  onTouchMove(event: TouchEvent) {
    if (event.touches.length === 2) {
      event.preventDefault();
      const touch1 = event.touches[0];
      const touch2 = event.touches[1];
      const distance = this.getTouchDistance(touch1, touch2);
      
      if (this.lastTouchDistance > 0) {
        const prevScale = this.scale;
        const scaleChange = distance / this.lastTouchDistance;
        this.scale = Math.min(Math.max(this.scale * scaleChange, this.minScale), this.maxScale);
        
        // Zoom towards pinch center
        if (this.imageSource) {
          const img = this.imageSource.nativeElement;
          const wrapper = img.parentElement; // demo-img-wrapper
          const container = wrapper.parentElement; // demo-img-container
          
          if (container) {
            const containerRect = container.getBoundingClientRect();
            // Get pinch center position relative to the container
            const pinchX = (touch1.clientX + touch2.clientX) / 2 - containerRect.left;
            const pinchY = (touch1.clientY + touch2.clientY) / 2 - containerRect.top;
            
            // Calculate center of container (since transform-origin is center)
            const centerX = containerRect.width / 2;
            const centerY = containerRect.height / 2;
            
            // Pinch offset from center
            const offsetX = pinchX - centerX;
            const offsetY = pinchY - centerY;
            
            const actualScaleChange = this.scale / prevScale;
            // Adjust translation to keep the point under the pinch fixed
            this.translateX = offsetX - (offsetX - this.translateX) * actualScaleChange;
            this.translateY = offsetY - (offsetY - this.translateY) * actualScaleChange;
          }
        }
        
        this.constrainPan();
      }
      
      this.lastTouchDistance = distance;
    } else if (event.touches.length === 1 && this.isDragging) {
      event.preventDefault();
      this.translateX = event.touches[0].clientX - this.dragStartX;
      this.translateY = event.touches[0].clientY - this.dragStartY;
      this.constrainPan();
    }
  }

  onTouchEnd(event: TouchEvent) {
    if (event.touches.length < 2) {
      this.lastTouchDistance = 0;
    }
    if (event.touches.length === 0) {
      this.isDragging = false;
      
      // Detect double-tap
      if (event.changedTouches.length === 1) {
        const now = Date.now();
        const touch = event.changedTouches[0];
        
        if (now - this.lastTapTime < 300 && 
            Math.abs(touch.clientX - this.lastTapX) < 50 && 
            Math.abs(touch.clientY - this.lastTapY) < 50) {
          // Double tap detected
          event.preventDefault();
          
          if (this.imageSource) {
            const wrapper = this.imageSource.nativeElement.parentElement;
            const container = wrapper?.parentElement;
            if (container) {
              const containerRect = container.getBoundingClientRect();
              const tapX = touch.clientX - containerRect.left;
              const tapY = touch.clientY - containerRect.top;
              
              this.zoomToPoint(tapX, tapY, containerRect.width, containerRect.height);
            }
          }
          
          this.lastTapTime = 0;
        } else {
          this.lastTapTime = now;
          this.lastTapX = touch.clientX;
          this.lastTapY = touch.clientY;
        }
      }
    }
  }

  // Helper to calculate distance between two touch points
  private getTouchDistance(touch1: Touch, touch2: Touch): number {
    const dx = touch1.clientX - touch2.clientX;
    const dy = touch1.clientY - touch2.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  // Zoom to a specific point, toggling between 100% and 200%
  private zoomToPoint(clickX: number, clickY: number, containerWidth: number, containerHeight: number) {
    const prevScale = this.scale;
    
    // Toggle between zoomed out (1x) and zoomed in (2x)
    if (this.scale > 1.1) {
      // Zoom out
      this.scale = 1;
      this.translateX = 0;
      this.translateY = 0;
    } else {
      // Zoom in to 200%
      this.scale = 2;
      
      // Calculate center of container
      const centerX = containerWidth / 2;
      const centerY = containerHeight / 2;
      
      // Click offset from center
      const offsetX = clickX - centerX;
      const offsetY = clickY - centerY;
      
      // Adjust translation to zoom toward the clicked point
      const scaleChange = this.scale / prevScale;
      this.translateX = offsetX - (offsetX - this.translateX) * scaleChange;
      this.translateY = offsetY - (offsetY - this.translateY) * scaleChange;
      
      this.constrainPan();
    }
  }

  // Constrain panning to keep image within bounds
  private constrainPan() {
    if (!this.imageSource) return;
    
    const img = this.imageSource.nativeElement;
    const wrapper = img.parentElement; // demo-img-wrapper
    const container = wrapper.parentElement; // demo-img-container
    
    if (!container) return;
    
    // Get the container dimensions (unaffected by the child's transform)
    const containerRect = container.getBoundingClientRect();
    
    // Calculate the maximum translation allowed based on scale
    // When scaled, the image grows from the center, so we can translate by at most
    // half the extra size gained from scaling to keep edges within bounds
    const maxTranslateX = (containerRect.width * (this.scale - 1)) / 2;
    const maxTranslateY = (containerRect.height * (this.scale - 1)) / 2;
    
    // Constrain translation to prevent image edges from detaching from viewport edges
    this.translateX = Math.min(Math.max(this.translateX, -maxTranslateX), maxTranslateX);
    this.translateY = Math.min(Math.max(this.translateY, -maxTranslateY), maxTranslateY);
    
    // If at minimum scale, reset position
    if (this.scale === this.minScale) {
      this.translateX = 0;
      this.translateY = 0;
    }
  }

  // Get transform style for the image wrapper
  getTransformStyle(): string {
    return `translate(${this.translateX}px, ${this.translateY}px) scale(${this.scale})`;
  }
}
